module.exports = __webpack_public_path__ + "static/media/karadaHineri.21e2d3d8.png";